module.exports = __webpack_public_path__ + "img/hc_pro_night_8.ceba1e88.jpg";